<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <div slot="right">
          <el-button
            :disabled="isLoading"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >{{ $t('button.cancel') }}
          </el-button>
          <el-button
            v-if="!isViewMode"
            :disabled="isLoading"
            size="mini"
            type="danger"
            icon="el-icon-upload2"
            @click="handleSave"
          >{{ $t('button.save') }}
          </el-button>
        </div>
      </list-page-header>
    </template>
    <div v-loading="isLoading">
      <el-form
        ref="form"
        :disabled="isLoading"
        :model="form"
        :rules="formRules"
        class="round-border-form"
        label-position="top"
        label-width="200"
      >
        <el-form-item
          label="Store"
          prop="store_id"
        >
          <el-select
            :placeholder="$t('placeholder.select')"
            v-model="form.store_id"
            filterable
          >
            <el-option
              v-for="item in storeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="Plan Name"
          prop="name"
        >
          <el-input
            v-model="form.name"
            clearable
          />
        </el-form-item>
        
        <el-form-item
          label="Plan Description"
          prop="description"
        >
          <el-input
            v-model="form.description"
            clearable
          />
        </el-form-item>

        <el-form-item
          label="Currency"
          prop="currency"
        >
          <el-select
            v-model="form.currency"
            label="currency"
            filterable
          >
            <el-option
              v-for="currency in currencyList"
              :key="currency.code"
              :label="currency.code"
              :value="currency.code"
            />
          </el-select>
        </el-form-item>

        <el-form-item 
          label="Start Date"
        >
          <el-date-picker
            v-model="form.start_date"
            :clearable="false"
            :placeholder="$t('placeholder.select')"
            type="date"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>

        <el-form-item
          label="Billing Interval"
          prop="billing_interval"
        >
          <el-select
            :placeholder="$t('placeholder.select')"
            v-model="form.billing_interval"
            filterable
          >
            <el-option
              v-for="item in billingIntervalList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="Payment Type"
        >
          <p>Manual</p>
        </el-form-item>

        <el-form-item
          label="Termination Date"
        >
          <p>{{terminationDate}}</p>
        </el-form-item>

        <el-form-item
          label="Total Price"
          prop="price"
        >
          <el-input
            v-model="form.price"
            clearable
          />
        </el-form-item>

      </el-form>

    </div>
  </sticky-header-layout>
</template>

<script>
import { reactive } from '@vue/composition-api'
import { getSubscriptionPlanDetail, createStoreSubscription } from '../../../api/stores'
import MarketplaceService from '../../../api/marketplace'
import ListPageHeader from '@/views/layout/components/ListPageHeader.vue'
import { i18n } from '@/lang'
import { getSubscriptions } from '../../../api/stores'

export default {
  name: 'StoreSubscriptionDetail',
  components: {
    ListPageHeader,
  },
  props: {
    // planId: {
    //   type: [Number],
    //   default: undefined,
    // },
  },
  data() {
    const d = new Date()
    const fromRule = reactive({
      store_id: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      name: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      description: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      price: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      // price_yearly: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      billing_interval: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      start_date: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      terminated_date: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      currency: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
    })

    return {
      storeList: [],
      currencyList: [],
      isLoading: true,
      form: {
        store_id: '',
        name: '',
        description: '',
        price: '',
        price_yearly: '',
        billing_interval: 'month',
        start_date: d.getFullYear()+'-'+("0" + (d.getMonth() + 1)).slice(-2)+'-'+("0" + d.getDate()).slice(-2),
        terminated_date: '',
        currency: '',
      },
      formRules: fromRule
    }
  },
  watch: {
    terminationDate: {
      immediate: true,
      handler(newValue, oldValue) {
        this.form.terminated_date = newValue
      },
    },
  },
  computed: {
    terminationDate() {
      let d = new Date(this.form.start_date)
      switch (this.form.billing_interval) {
        case 'month':
          d.setMonth(d.getMonth() + 1);
          break
        case 'year':
          d.setYear(d.getFullYear() + 1);
          break
        case '2-year':
          d.setYear(d.getFullYear() + 2);
          break
      }
      return d.getFullYear()+'-'+("0" + (d.getMonth() + 1)).slice(-2)+'-'+("0" + d.getDate()).slice(-2)
    },
    billingIntervalList() {
      return ['month', 'year', '2-year']
    },
    isViewMode() {
      return !!this.planId
    },
    canSave() {
      return !this.loading
    },
  },
  mounted() {
    // if (this.isViewMode) {
    //   this.getDetail(this.id)
    // } else {
      this.getStoreList()
      this.getCurrencyList()
    // }
  },
  methods: {
    // async getDetail() {
    //   this.isLoading = true
    //   try {
    //     const response = await getSubscriptionPlanDetail(this.planId)
    //     // console.log(response)
    //     const { data } = response
    //     this.form = {
    //       store_id: data.store_id,
    //       store_name: data.store_name,
    //       name: data.name,
    //       description: data.description,
    //       billing_interval: data.billing_interval,
    //       price: data.price,
    //       price_yearly: data.price_yearly,
    //       currency: data.currency,
    //     }
        
    //     this.isLoading = false
    //   } catch (error) {
    //     this.isLoading = false
    //   }
    // },
    async getStoreList() {
      this.isLoading = true
      this.storeList = []

      try {
        const response = await getSubscriptions({})

        if (Array.isArray(response.data)) {
          this.storeList = response.data
        }

        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    async getCurrencyList() {
      const res = await MarketplaceService.getCurrencyList()
      this.currencyList = [...res.data]
    },
    async handleSave() {
      try {
        await this.$refs.form.validate()

        this.createStoreSubscription(this.form.store_id, this.form)
        // console.log(this.form)
      } catch (error) {
        this.$alert('Please fill in all the required information.', 'Oops..', {
          confirmButtonText: 'OK',
        })
      }
    },
    handleCancel() {
      this.$router.push({ path: `/store/subscription/list` })
    },
    async createStoreSubscription(store_id, form) {
      this.isLoading = true
      try {
        const result = await createStoreSubscription(store_id, form)
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    handleSaveSuccess() {
      this.isLoading = false
      this.$router.push({ path: `/store/subscription/list` })
    },
    handleSaveFail(error) {
      this.isLoading = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: 'OK',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/form.scss";
@import "~@/assets/styles/table.scss";
p {
  margin: 0 10px; 
}
</style>

